import * as React from "react"
import CtxHeroSection from "../../../common/sections/ctx-hero-section/CtxHeroSection"
import { navigate } from "gatsby"
import { getHoraireData } from "../../../../../utils/horairesLib"

const CtxEnteteAgenceSection = ({ backgroundImage, agencyData }) => {
  const horairesData = getHoraireData()

  const tel = agencyData.attributes.telephoneReal.split('').map((v,i)=>i%2 ===0 ? ' '+v:v).join('')


  return (
    <>
      <CtxHeroSection
        image={backgroundImage}
        imgSrc={backgroundImage.url}
        imgAlt={backgroundImage.alt}
        classes="mb-5"
      >
        <div className="row clearfix hero_page_agence container flex items-center relative">
          <div className="column full flex col flex-direction-column justify-content-center fade-in-bottom">
            <div
              className="card container card_bottom flex flex-direction-column p-3 fade-in-bottom gap-2 ml-0"
              style={{ maxWidth: "630px", width: "100%" }}
            >
              <h1>Agence de {agencyData.attributes.name}</h1>
              <time
                itemprop="openingHours"
                datetime="Mo-Fr 09:00-17:00"
                className="flex align-items-center gap-2"
                style={{ color: horairesData.isOpen?"var(--valid-color)":"var(--invalid-color)" }}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="8"
                    cy="8"
                    r="8"
                    fill={horairesData.isOpen?"var(--valid-color)":"var(--invalid-color)"}
                  ></circle>
                </svg>
                {horairesData.horaireText}
              </time>
              <address>{agencyData.attributes.address}</address>
              <p style={{ fontSize: "14px" }}>
                Notre équipe est joignable au téléphone
                <br />
                du lundi au vendredi de 9h à 12h45 et de 13h45 à 17h.
              </p>
              <div className="buttons flex gap-3">
                <a
                  href="#"
                  className="button contrastant primary large"
                  onClick={() => {
                    navigate("/pop-in/rendez-vous-1", {
                      state: {
                        modal: true,
                      },
                    })
                  }}
                >
                  Prendre rendez-vous
                </a>
                <a
                  href={"tel:" + agencyData.attributes.telephone}
                  className="button classique primary large"
                >
                  {tel}
                </a>
              </div>
            </div>
          </div>
        </div>
      </CtxHeroSection>
      <div class="spacer" style={{height: "120px"}}></div>
    </>
  )
}

export const name = "CtxEnteteAgenceSection"

export const init = (componentData, pageContext) => {
  return (
    <CtxEnteteAgenceSection
      key={componentData.id}
      backgroundImage={pageContext.itemData.attributes.headerImage.data ? pageContext.itemData.attributes.headerImage.data.attributes : componentData.backgroundImage.data?.attributes}
      agencyData={pageContext.itemData}
    />
  )
}

export default CtxEnteteAgenceSection
